
import { Options, mixins } from "vue-class-component";
import TabMenu from "primevue/tabmenu";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import router from "../router";
import { useStore, ActionTypes } from "../store";
import Toaster from "../helpers/Toaster";
import UtilityOptions from "../mixins/UtilityOptions";
import UserAuthentication from "../service/UserAuthentication";
import HomepageService from "../service/HomepageService";
import FooterService from "../service/footerService";
import PermissionsService from "../service/PermissionService";

@Options({
    components: {
        TabMenu,
        Dialog,
        Dropdown,
        Button,
    },
})
export default class Header extends mixins(UtilityOptions) {
    private showProgress = false;
    private showDialog = false;
    private isSwitching = false;
    private switchBranchAvail = false;
    
    // Current displayed values
    private currentPharmacyName = "";
    private currentBranchName = "";
    private currentBranchId: any = "";
    private currentPharmacyId: any = "";
    
    // Selection values in dialog
    private selectedPharmacyId: any = "";
    private selectedBranchId: any = "";
    
    // Data
    private pharmacies: any[] = [];
    private branches: any[] = [];

    mounted() {
        console.log("token_queue permission:", this.can("token_queue"));
        // Focus the div to capture keys
        window.addEventListener("keypress", this.handleKeypress);
        localStorage.setItem("confirm_dialog", "0");
        localStorage.setItem("pos_items", "0");
        localStorage.setItem("pur_items", "0");
        
        // Load initial branch data
        this.loadBranchData();
        this.checkPermissions();
    }

    checkPermissions() {
        const permissionService = new PermissionsService();
        if(permissionService.can('switch_branches')){
            this.switchBranchAvail = true;
        }
    }

    beforeUnmount() {
        // Remove event listener
        window.removeEventListener("keypress", this.handleKeypress);
    }

    loadBranchData() {
        const footerService = new FooterService();
        footerService.branchDetail().then((res) => {
            console.log('Header - API Response:', res);
            this.pharmacies = res.pharmacies || [];
            
            // Set current branch info from API
            if (res.store_info) {
                this.currentBranchId = res.store_info.id;
                this.currentBranchName = res.store_info.name || "Unknown Branch";
                this.currentPharmacyId = res.store_info.pharmacy_id;
                this.currentPharmacyName = res.store_info.pharmacy.name;
                
                console.log('Header - Branch Info:', {
                    branchId: this.currentBranchId,
                    branchName: this.currentBranchName,
                    pharmacyId: this.currentPharmacyId,
                    pharmacyName: this.currentPharmacyName
                });
                
            } else {
                console.error('Header - No storeInfo in response');
                this.currentPharmacyName = "No Store Info";
                this.currentBranchName = "No Store Info";
            }
        }).catch((error) => {
            console.error("Error loading branch data:", error);
            this.currentPharmacyName = "Error loading";
            this.currentBranchName = "Error loading";
        });
    }

    openDialog() {
        // Pre-populate dialog with current selections
        this.selectedPharmacyId = this.currentPharmacyId;
        this.selectedBranchId = this.currentBranchId;
        
        // Load branches for current pharmacy
        const pharmacy = this.pharmacies.find(p => p.id == this.currentPharmacyId);
        if (pharmacy) {
            this.branches = pharmacy.branches || [];
        }
        
        // Open dialog
        this.showDialog = true;
    }

    onPharmacyChange() {
        const pharmacy = this.pharmacies.find(p => p.id == this.selectedPharmacyId);
        if (pharmacy) {
            this.branches = pharmacy.branches || [];
            // Reset branch selection
            this.selectedBranchId = "";
        }
    }

    switchBranch() {
        if (!this.selectedBranchId) {
            return;
        }

        const branch = this.branches.find(b => b.id == this.selectedBranchId);
        if (!branch) {
            return;
        }

        this.isSwitching = true;
        const homeService = new HomepageService();
        homeService.setBranch(this.selectedBranchId).then((res) => {
            const toast = new Toaster();
            
            if(res.success) {
                toast.showSuccess(res.message || 'Branch changed to ' + branch.name + ' successfully');
                
                // Update current displayed values
                this.currentBranchId = this.selectedBranchId;
                this.currentBranchName = branch.name;
                
                const pharmacy = this.pharmacies.find(p => p.id == this.selectedPharmacyId);
                if (pharmacy) {
                    this.currentPharmacyId = this.selectedPharmacyId;
                    this.currentPharmacyName = pharmacy.name;
                }
                
                // Close dialog
                this.showDialog = false;
                
                // Reload page to reflect changes
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                // Show error message and keep dialog open
                toast.showError(res.message || "You do not have access to this branch");
                // Reset selection to current branch
                this.selectedBranchId = this.currentBranchId;
                this.selectedPharmacyId = this.currentPharmacyId;
                // Reload branches for current pharmacy
                const pharmacy = this.pharmacies.find(p => p.id == this.currentPharmacyId);
                if (pharmacy) {
                    this.branches = pharmacy.branches || [];
                }
            }
            this.isSwitching = false;
        }).catch((error) => {
            console.error("Error switching branch:", error);
            this.isSwitching = false;
            const toast = new Toaster();
            toast.showError(error.response?.data?.message || "Failed to change branch");
            // Reset selection to current branch
            this.selectedBranchId = this.currentBranchId;
            this.selectedPharmacyId = this.currentPharmacyId;
        });
    }

    handleKeypress(event) {
        // console.log('Key pressed:', event.key, 'KeyCode:', event.keyCode);

        // Ignore keypress if user is typing in an input, textarea, or contenteditable element
        const target = event.target as HTMLElement;
        const tagName = target.tagName.toLowerCase();
        const isEditable = target.isContentEditable;
        
        if (tagName === 'input' || tagName === 'textarea' || isEditable) {
            return;
        }

        if (event.keyCode === 43) {
            // Key "\"
            //  go to POS
            router.push({ path: "/pos" });
            return "";
        }
        if (event.keyCode === 124) {
            // Key "|" (shift + \)
            //  go to POS-Refund
            router.push({ path: "/pos-refund" });
            return "";
        }
        if (event.keyCode === 42) {
            // F12 example
            // console.log('F12 was pressed!');
        }
    }

    get menuItems() {
        const newList = this.items.filter((e) => {
            const p = this.can(e.permission);
            if ((e.permission != "" && p == true) || e.name == "More") return e;
        });

        newList.forEach((e) => {
            if (e.items != undefined) {
                e.items.forEach((i, j) => {
                    const p = this.can(i.permission);
                    if (
                        i.permission != "" &&
                        p == false &&
                        i.name != "Logout"
                    ) {
                        e.items.splice(j, 1);
                    }
                });
            }
        });

        return newList;
    }

    private items = [
        {
            label: "Dashboard",
            name: "Dashboard",
            permission: "dashboard",
            icon: "pi pi-fw pi-home",
            to: "/home/dashboard",
        },
        {
            label: "POS",
            name: "Orders",
            permission: "orders",
            icon: "pi pi-fw pi-shopping-cart",
            to: "/pos",
        },
        {
            label: "TOKEN",
            name: "TokenQueue",
            permission: "orders", 
            icon: "pi pi-fw pi-ticket",
            to: "/pos-token",
        },
        // {
        //   label: "Banking",
        //   name:"Banking",
        // permission: "dashboard",
        //   icon: "pi pi-fw pi-check-circle",
        //   to: "/store/banking"
        // },
        {
            label: "Purchases",
            name: "Purchasing",
            permission: "purchasing",
            icon: "pi pi-fw pi-table",
            to: "/purchasing",
        },
        {
            label: "Transactions",
            name: "Transaction Receipt",
            permission: "transaction_receipt",
            icon: "pi pi-fw pi-window-maximize",
            to: "/process/transactions",
        },
        {
            label: "More",
            name: "More",
            icon: "pi pi-fw pi-plus-circle",
            items: [
                {
                    label: "Cashier Sessions",
                    name: "Cashier Sessions",
                    permission: "view_cashier_session",
                    icon: "pi pi-fw pi-window-maximize",
                    to: "/cashier/cashier-session",
                },
                {
                    label: "Settings",
                    name: "Settings",
                    permission: "initialization",
                    icon: "pi pi-fw pi-cog",
                    to: "/home/initialization",
                },
                {
                    label: "Reports",
                    name: "Report",
                    permission: "report",
                    icon: "pi pi-fw pi-chart-bar",
                    to: "/report/index",
                },
                {
                    label: "Logout",
                    name: "Logout",
                    permission: "logout",
                    icon: "pi pi-fw pi-power-off",
                    command: () => this.logOut(),
                },
            ],
        },
    ];

    logOut() {
        const auth = new UserAuthentication();
        const store = useStore();
        this.showProgress = true;

        auth.logoutUser()
            .then((res) => {
                // console.log("LOGOUT RESPONSE ", res);

                const toast = new Toaster();

                const res2 = {
                    alert: "info",
                    msg: "Sign out successfully",
                };

                toast.handleResponse(res2);

                this.store.dispatch(ActionTypes.AUTH_LOGOUT, "");

                document.cookie =
                    "laravel_session=; Max-Age=0; path=/; domain=your-domain.com; secure;";
                document.cookie =
                    "XSRF-TOKEN=; Max-Age=0; path=/; domain=your-domain.com; secure;";

                router.push({ path: "/login" });
            })
            .catch((error) => {
                this.showProgress = false;
                console.error("Login error:", error);
            });
    }

    get progressBar() {
        return this.store.getters.getProgressBar;
    }
}
